import React from "react";
import ErrorMessage from "./Error";

interface ErrorMessageProps {
  message?: string | null;
}

const ErrorMessageWithContainer: React.FC<ErrorMessageProps> = ({
  message = "Error Occured",
}) => {
  return (
    <div className="global-container">
      <ErrorMessage message={message} />
    </div>
  );
};

export default ErrorMessageWithContainer;
